import { useQuery } from '@tanstack/react-query';
import { queueApiService, type OptinConfig } from '@/services/queueApi.service';

export const useOptinsConfig = (queueId: string) => {
  return useQuery<OptinConfig[]>({
    queryKey: ['event-optins', queueId],
    queryFn: async () => {
      if (!queueId) return [];

      try {
        const queue = await queueApiService.getPublicQueueInfo(queueId);
        if (!queue?.eventId) return [];

        const optins = await queueApiService.getEventOptins(queue.eventId);
        return optins || [];
      } catch (error) {
        console.error('[useOptinsConfig] Error fetching optins:', error);
        return [];
      }
    },
    enabled: !!queueId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
